import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { UseQueryOptionsWithoutQueryFn } from '~/types/util/tanstack-query'

import type { IncludableField } from './useFetchUserTemplateV2'

import { responseDataTypeName, useFetchUserTemplateV2 } from './useFetchUserTemplateV2'

export const queryKeys = createQueryKeys(responseDataTypeName, {
  byId: ({
    id,
    fieldsToInclude,
  }: {
    id?: MaybeRef<string>
    fieldsToInclude?: readonly string[]
  }) => ({ queryKey: [{
    id,
    ...(fieldsToInclude ? { fieldsToInclude: fieldsToInclude.toSorted() } : {}),
  }] }),
})

const byId = <T extends IncludableField[] = []>({
  id,
  fieldsToInclude,
  useQueryOptions = {},
}: {
  id: MaybeRef<string>
  fieldsToInclude?: T
  useQueryOptions?: UseQueryOptionsWithoutQueryFn
}) => {
  const { activeWorkspaceId } = useAuth()
  const { getById } = useFetchUserTemplateV2()

  return useQuery({
    ...queryKeys.byId({ id, fieldsToInclude }),
    queryFn: () => getById({
      id: unref(id),
      workspaceId: unref(activeWorkspaceId) || '',
      fieldsToInclude,
    }),
    enabled: () => !!unref(activeWorkspaceId),
    ...useQueryOptions,
  })
}

export const useQueryUserTemplateV2 = {
  byId,
}
